import {Col, Grid, Row} from '@freecodecamp/react-bootstrap';
import React, {ReactElement, useEffect, useState} from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import AsSeenIn from './components/as-seen-in';
import Certifications from './components/certifications';
import LandingTop from './components/landing-top';
import Testimonials from './components/testimonials';

import './landing.css';
import LearnLayout from "../layouts/learn";
import Map from "../Map";
import {Spacer} from "../helpers";

function Landing(): ReactElement {
  const { t } = useTranslation();
    const [userAccessLevel, setUserAccessLevel] = useState(4);
    useEffect(() => {
        const windowUrl = window.location.search;
        const params = new URLSearchParams(windowUrl);
        const userId = params.get('user_id');
        const cId = params.get('c_id');
        let level = params.get('tier')
        if (!level){
            level = "4";
        }
        // if (!userId || !cId) {
        //   navigate('/404');
        // }
        setUserAccessLevel(parseInt(level));
        // console.log('https://connector.krakentech.net/api/v1/user-info/' + userId +'/' + cId)
        // if (userId) {
        //   axios
        //     .get('https://connector.krakentech.net/api/v1/user-info/' + userId +'/' + cId, {
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'X-API-Key':
        //           'YgdUZLiGLYaRBZdhDjw2sjqWwmjEEl9LX07rCMJjulVNWjk5f9PPD1gCg9gxutUv'
        //       }
        //     })
        //     .then((response: ApiResponse) => {
        //       console.log('response---', response);
        //       const accessLevel: Array<number[]> =
        //         response?.data?.webshopAccessLevels;
        //       setUserAccessLevel(accessLevel[0]);
        //     })
        //     .catch(() => {
        //       console.log('Error');
        //       navigate('/404');
        //     });
        // }
    }, []);
  return (
    <>
      <Helmet>
        <title>{t('metaTags:title')}</title>
      </Helmet>
        <LearnLayout>
            <Helmet title={t('metaTags:title')} />
            <Grid>
                <Row>
                    <Col md={8} mdOffset={2} sm={10} smOffset={1} xs={12}>
                        <Map userAccessLevel={userAccessLevel} />
                        <Spacer size={2} />
                    </Col>
                </Row>
            </Grid>
        </LearnLayout>
    </>
  );
}

Landing.displayName = 'Landing';
export default Landing;
